var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"indexBg"},[_c('div',{staticClass:"box",class:{ 'is-visible': _vm.showBox }},[_c('div',{staticClass:"endText"},[_vm._v(" 共用时："),_c('span',[_vm._v(_vm._s(_vm.formattedTime))])])]),_c('div',{staticClass:"submit",class:{ 'is-visible': _vm.showSubmit },on:{"click":_vm.finishAndNavigate}})])
}
var staticRenderFns = []

export { render, staticRenderFns }